import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

import Alert from 'components/alert';
import { put } from 'helpers/api';
import debounce from 'lodash/debounce';
import ManagedInput from 'components/form/managed_input';

import './styles/defaults_editor.scss';

export default class PipelineDefaultsEditor extends React.Component {
  static propTypes = {
    companyPipelineSettingsPath: PropTypes.string.isRequired,
    percentageLikelyToCloseDefaults: PropTypes.shape({
      proposal: PropTypes.number,
      onMarket: PropTypes.number,
      underContract: PropTypes.number,
    }).isRequired,
  }

  state = {
    percentageLikelyToCloseDefaults: {
      proposal: this.props.percentageLikelyToCloseDefaults.proposal,
      onMarket: this.props.percentageLikelyToCloseDefaults.onMarket,
      underContract: this.props.percentageLikelyToCloseDefaults.underContract,
    },
  }

  debouncedSave = debounce(() => {
    const { percentageLikelyToCloseDefaults } = this.state;

    put(this.props.companyPipelineSettingsPath, { percentageLikelyToCloseDefaults })
      .then(() => {
        clearTimeout(this.state.successFadeId);
        this.setState({
          success: true,
          savedAtLeastOnce: true,
          successFadeId: setTimeout(() => this.setState({ success: false }), 1000),
        });
      })
      .catch(errors => this.setState({ errors }));
  }, 500);

  handleChange = (change) => {
    this.setState(({ percentageLikelyToCloseDefaults }) => ({
      percentageLikelyToCloseDefaults: {
        ...percentageLikelyToCloseDefaults,
        ...change,
      },
      errors: null,
    }), this.debouncedSave);
  }

  render() {
    return <React.Fragment>
      {this.renderHeader()}
      <div className="row pipeline-settings form-horizontal">
        <div className="col-xs-6">
          {this.renderInput('proposal', 'Proposal', 'proposal')}
          {this.renderInput('onMarket', 'Active / Touring', 'on-market')}
          {this.renderInput('underContract', 'Under Contract', 'under-contract')}
          {this.renderInput('closed', 'Closed', 'closed', 100)}
        </div>
      </div>
    </React.Fragment>;
  }

  renderHeader() {
    return <React.Fragment>
      <h2>
        Pipeline Settings
        {this.renderSuccess()}
      </h2>
      <p>Set default prediction values for your pipeline</p>
      {this.renderErrors()}
    </React.Fragment>;
  }

  renderInput(name, label, className, value) {
    return (
      <div className="form-group mb-5">
        <div className={`pipeline-setting-header ${className}`}>{label}</div>
        <div className="control-label">% likely to close</div>
        <div className="form-input-container">
          <ManagedInput
            className="form-control"
            disabled={!!value}
            max="100"
            min="1"
            name={name}
            type="number"
            value={value || this.state.percentageLikelyToCloseDefaults[name]}
            onChange={this.handleChange}
          />
        </div>
      </div>
    );
  }

  renderErrors() {
    if (this.state.errors) {
      return <Alert className="mb-0" messages={this.state.errors} />;
    }
  }

  renderSuccess() {
    const { success, savedAtLeastOnce } = this.state;
    const className = classNames('success-notification', 'text-success', 'ml-4', { visible: success });

    if (savedAtLeastOnce) {
      return (
        <small className={className} name="success-message">
          <FontAwesomeIcon className="mr-2" icon={faCheck} />
          Changes saved successfully
        </small>
      );
    }
  }
}
